/* MoonSkin — счётчик сквозной аналитики.
   Ставит client_id посетителю, шлёт хит на каждой странице и кладёт
   client_id + session_id в атрибуты корзины, чтобы они доехали до заказа.

   Хранение тройное: cookie → localStorage → переменная в памяти. Если куки
   заблокированы (iOS, блокировщики), посетитель не теряется — именно из-за
   этого у аналитики на одних куках атрибуция проваливается почти вдвое.

   Решение «новая сессия или продолжение» принимает сервер (30 мин простоя,
   смена дня, смена источника) — скрипт только отдаёт client_id и хранит ответ.
   Скрипт никогда не должен ломать витрину: всё в try/catch, ошибки молча гасим.
*/
(function () {
  'use strict';
  var ENDPOINT = 'https://wh7.moon-skin.eu/api/track';
  var CI_KEY = 'ms_ci', SI_KEY = 'ms_si';
  var mem = {}; // третий уровень хранения — переживает SPA-переходы

  function readCookie(n) {
    try {
      var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
      return m ? decodeURIComponent(m[2]) : null;
    } catch (e) { return null; }
  }
  function writeCookie(n, v, days) {
    try {
      var d = new Date(Date.now() + days * 864e5);
      document.cookie = n + '=' + encodeURIComponent(v) + ';expires=' + d.toUTCString() +
        ';path=/;SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : '');
    } catch (e) {}
  }
  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function get(k) { return readCookie(k) || ls(k) || mem[k] || null; }
  function set(k, v, days) { writeCookie(k, v, days || 730); ls(k, v); mem[k] = v; }

  // client_id формата <random>.<ms первого визита> — вторая часть даёт дату
  // первого визита без отдельного поля.
  function clientId() {
    var v = get(CI_KEY);
    if (v && v.indexOf('.') > 0) return v;
    v = (Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).slice(0, 16) + '.' + Date.now();
    set(CI_KEY, v, 730);
    return v;
  }

  function device() {
    var w = window.innerWidth || 1024;
    return w < 768 ? 'mobile' : w < 1100 ? 'tablet' : 'desktop';
  }

  // Атрибуты корзины пишем ТОЛЬКО когда в корзине что-то есть: пустой
  // /cart/update.js создал бы корзину каждому визитёру и раздул брошенные.
  function tagCart(ci, si) {
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.item_count) return;
          var a = cart.attributes || {};
          if (a.ms_ci === ci && a.ms_si === si) return; // уже проставлено
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ attributes: { ms_ci: ci, ms_si: si } })
          });
        })
        .catch(function () {});
    } catch (e) {}
  }

  function hit() {
    var ci = clientId();
    var body = {
      ci: ci,
      h: location.href.slice(0, 2000),
      r: (document.referrer || '').slice(0, 2000),
      e: 'pageview',
      device: device()
    };
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
        mode: 'cors'
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.sessionId) return;
          set(SI_KEY, d.sessionId, 1);
          window.msAnalytics = { clientId: ci, sessionId: d.sessionId, source: d.source };
          tagCart(ci, d.sessionId);
        })
        .catch(function () {});
    } catch (e) {}
  }

  // Корзина могла наполниться после загрузки — проставим атрибуты и на добавление.
  document.addEventListener('click', function (e) {
    try {
      var t = e.target.closest('[name="add"], .product-form__submit, [data-add-to-cart]');
      if (!t) return;
      setTimeout(function () {
        var s = window.msAnalytics;
        if (s) tagCart(s.clientId, s.sessionId);
      }, 1200);
    } catch (err) {}
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hit);
  else hit();
})();
